controllers.controller('AssetsController', [
    '$scope', '$state', '$ionicPopover', '$ionicLoading', '$injector',
    'config', 'constants', 'AssetService', 'API', 'FavoritesService', 'LocaleService', 'UserService', 'UserControl',
    'LocalStorage', '$rootScope',
    function ($scope, $state, $ionicPopover, $ionicLoading, $injector,
              config, Const, AssetService, API, FavoritesService, LocaleService, UserService, UserControl, LocalStorage,
              $rootScope) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });
        $scope.state = null;
        $scope.categories = filterCategories(AssetService.assetCategories || Const.assetsTypes);
        $scope.quickAccessExists = $scope.assets = AssetService.clientQuickAccessCollection.getAll().length > 0;
        $scope.showSearch = false;
        $scope.search = {};

        var category = $state.params.category;
        $scope.constants = Const;

        $ionicPopover.fromTemplateUrl('templates/instruments-menu.html', {
            scope: $scope.$new()
        }).then(function (popover) {
            $scope.popover = popover;
        });

        $scope.openPopover = function ($event) {
            $scope.popover.show($event);
        };

        $scope.openSearchAssets = function () {
            $scope.showSearch = !$scope.showSearch;
            if ($scope.showSearch) {
                $scope.assets = AssetService.clientCollection.getAll();
            } else {
                $scope.search = {};
                filterAssets($scope.selectedIndex);
            }
        };
        $scope.navigate = function (state, params) {
            $scope.popover && $scope.popover.remove();
            $state.go(state, params);
        };

        $scope.assets = [];

        updateSelectedIndex();

        function updateSelectedIndex() {
            $scope.selectedIndex = category
                ? category
                : (FavoritesService.length() > 0 ? 'FAVORITES' : $scope.categories[0].id);
        }

        filterAssets($scope.selectedIndex);

        $scope.toggleCategory = function (category) {
            $scope.selectedIndex = category;
            filterAssets(category);
        };

        $scope.user = UserService.get();

        function refreshView() {
            log('init assets controller after switch account');

            if ($scope.selectedIndex === 'FAVORITES') {
                return filterAssets($scope.selectedIndex);
            }
            return filterAssets($scope.selectedIndex);
        }

        //refilter favorite assets on view enter
        $scope.$on('$ionicView.beforeEnter', function () {
            $scope.state = UserControl.getState();
            return refreshView();
        });

        $scope.$on('init', refreshView);

        $scope.$on('clear', function () {
            log('clear assets controller');
            $scope.assets = [];
            $scope.popover.remove();
        });

        $scope.$on('$ionicView.afterEnter', function () {
            var linkRaw = LocalStorage.get('link');
            if (!linkRaw) {
                return;
            }

            var link = JSON.parse(linkRaw);
            if (link.name === 'asset') {
                LocalStorage.remove('link');
                var asset = AssetService.getAssetByName(link.params);
                if (asset) {
                    return $state.go('root.app.chart', {category: asset.category, assetId: asset.id});
                }
            }
        });

        $rootScope.$on('reconnect', function () {
            refreshView();
        });

        function filterCategories(categories) {
            if (!AssetService.collection) return;

            var uniqCategories = _.uniq(AssetService.clientCollection.getAll()
                .map(function (asset) {
                    return asset.category
                }));

            var filteredCategories = categories.filter(function (category) {
                return uniqCategories.indexOf(category.id) > -1
            });

            //set selected to false
            filteredCategories = filteredCategories.map(function (category) {
                return _.assign(category, {selected: false})
            });
            //set selected to first category which is not favorites
            filteredCategories[0].selected = true;
            return filteredCategories;
        }

        function filterAssets(category) {

            if (!AssetService.collection) return;

            var filter = {};

            if (category === 'FAVORITES') {
                filter.isFavorite = true;
                $scope.assets = AssetService.sortByFavorites(filter);
            }
            else if (category === 'QUICK ACCESS'){
                $scope.assets = AssetService.clientQuickAccessCollection.getAll();
            } else {
                filter.category = category;
                $scope.assets = AssetService.clientCollection.find(filter);
            }
        }

        $scope.customSearch = function (asset, index, array) {

            if (!$scope.search || !$scope.search.outputName) {
                return asset.category.length > 0
            }

            return asset.outputName.toLowerCase().indexOf($scope.search.outputName.toLowerCase()) >= 0
                && asset.category.length > 0
        }

    }]);
